import { useLanguage } from '../i18n/LanguageContext';

export default function Privacy() {
  const { t } = useLanguage();
  const privacy = t.privacy || {};
  const sections = Array.isArray(privacy.sections) ? privacy.sections : [];

  return (
    <div>
      <div className="page-header documents-page">
        <h1>{privacy.title}</h1>
        {privacy.intro && <p>{privacy.intro}</p>}
        {privacy.updated && <p className="privacy-updated">{privacy.updated}</p>}

        {sections.map((section) => (
          <section key={section.title} className="document-section">
            {section.title && <h2>{section.title}</h2>}

            {Array.isArray(section.paragraphs) &&
              section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}

            {Array.isArray(section.bullets) && section.bullets.length > 0 && (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}

            {/* Odstavki, ki morajo stati za seznamom, ne pred njim. */}
            {Array.isArray(section.extra) &&
              section.extra.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </section>
        ))}
      </div>
    </div>
  );
}
